import { InjectionToken } from "@angular/core";
import { AddressDto } from "projects/shared/lib/services/INTEGRA_Shop_Client";

export abstract class IAddressSelectDialogService
{

  abstract addressSelectDialogShow(
    modalTitle: string,
    addressList: AddressDto[],
    callbackSubmit: (result: AddressDto) => void,
    callbackCancel: () => void
  ): unknown;

}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IAddressSelectDialogServiceToken = new InjectionToken<IAddressSelectDialogService>('IAddressSelectDialogServiceToken');
